<template>
    <div class="d-flex align-items-center justify-content-center">
        <ul class="list-group w-100">
            <li class="list-group-item py-25 px-50" v-for="(g,i) in row.GRUPLAR" :key="i">
                <span> {{ g.GRUP_ISIM }} </span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props:{
        row:Object,
        field:Object
    },
}
</script>

<style>

</style>